module.exports = __webpack_public_path__ + "static/media/mssg_menu_pt_PT.47ccce5f.png";